import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { doToggle } from '@src/components/templates/util.js';
import { features as featureDef } from '@src/defs/features.js';
import { ConsentType } from '@src/types/common.js';
import { encodeHtmlEntities } from '@src/util/helpers.js';

export const featuresTemplate = (consent: ConsentType, disabled: boolean, id: string) => {
  const existedFeatures = featureDef.filter((feature) => consent[feature]);
  return html`
      ${existedFeatures /* eslint-disable @typescript-eslint/indent */
        .map((feature) => consent[feature]?.map(({
           id: fid, granted, title, description,
          }) => {
          const featureLabel = (
            description === title
              ? title
              : `<div>
                <abbr title="${encodeHtmlEntities(description)}">
                  ${title}
                </abbr>
              </div>`);
          const checkboxId = `${id}_${feature}_${fid}`;
          if (disabled) {
            return html`
            <one-list icon="${consent.granted ? 'check' : 'cancel'}" size="lg">
              <one-list-item>
                <one-icon name="${granted ? 'check' : 'cancel'}" variant="outline" slot="icon">
                </one-icon>
                <one-content>
                    ${unsafeHTML(featureLabel)}
                </one-content>
              </one-list-item>
            </one-list>
            `;
          }
          return html`
              <one-cluster gap="xxs" no-wrap>
                <one-checkbox
                  id=${checkboxId}
                  name=${checkboxId}
                  type="checkbox"
                  .checked=${granted}
                  @change=${doToggle({
                    id,
                    fid,
                    feature,
                  })}
                  variant="outline"
                ></one-checkbox>
                <one-content>
                    ${unsafeHTML(featureLabel)}
                </one-content>
              </one-cluster>
            `;
        }))
      /* eslint-enable @typescript-eslint/indent */}
    `;
};
